import { bringYourOwnDataConfig } from "./bring-your-own-data";
import { exploreDatasetConfig } from "./explore-dataset";
import type { ModuleConfig } from "./types";
import { workspaceTourConfig } from "./workspace-tour";

// Private registry of tour configs, keyed by module code. Step definitions
// carry JS callbacks (onActivate/onNext) and Redux seed data, so they must
// live in code — but nothing outside this module needs the whole map. Call
// sites resolve a single config via getModuleConfig(code).
const CONFIG_BY_CODE: Record<string, ModuleConfig> = {
  [workspaceTourConfig.code]: workspaceTourConfig,
  [exploreDatasetConfig.code]: exploreDatasetConfig,
  [bringYourOwnDataConfig.code]: bringYourOwnDataConfig
};

/**
 * Resolves the tour config for a module code, or null when the code is empty
 * or has no registered walkthrough. The null case is expected: the Product
 * Overview panel lists every module returned by the BE, some of which may not
 * have a local tour yet.
 */
export const getModuleConfig = (
  code: string | null | undefined
): ModuleConfig | null => (code ? (CONFIG_BY_CODE[code] ?? null) : null);

export type {
  ModuleConfig,
  ModuleIntroAction,
  ModuleIntroConfig,
  ModuleSeedConfig,
  TourStep
} from "./types";
